import { api } from '@/common/api';
import qs from 'qs';

const store = {
    namespaced: true,
    state() {
        return {
        };
    },

    mutations: {
    },
    actions: {
        find(context, params) {
            return new Promise((resolve, reject) => {
                api.post('/search', params).then(
                    response => {
                        resolve(response);
                    },
                    error => {
                        reject(error);
                    });
            });
        },
        getPaginatedList(context, params) {
            return new Promise((resolve, reject) => {
                api.get('/search/?' + qs.stringify(params)).then(response => {
                    resolve(response);
                }).catch(
                    error => {
                        reject(error);
                    });
            });
        },
        async searchContactByDeals({ state, commit }, params) {
            try {
                const response = await api.post('/search/contact-by-deal', params);
                return response.data.data;
            } catch (e) {
                throw new Error('Произошла ошибка: ' + e.response.data.error);
            }
        },
        async searchDealsByContractNumber({ state, commit }, params) {
            try {
                const response = await api.post('/search/deals-by-contract', params);
                return response.data.data;
            } catch (e) {
                throw new Error('Произошла ошибка: ' + e.response.data.error);
            }
        }
    },
    getters: {}

};

export default store;
